export function extractAuthTokenFromAdapter(adapter) {
  return adapter.http.defaults.headers.Authorization.split('Bearer ')[1];
}
//# sourceMappingURL=adapters.js.map